import { cx } from '../lib/cx';
import { Icon } from './Icon';
import { Spinner } from './feedback';

export interface SyncIndicatorProps {
  pending: number;
  rejected: number;
  online: boolean;
  flushing: boolean;
  stale: boolean;
  labels: { synced: string; pending: string; offline: string; problem: string; syncing: string };
  onClick?: () => void;
  compact?: boolean;
}

/** "3 items waiting to sync" / "Everything is synced" (ADR-0006). */
export function SyncIndicator({ pending, rejected, online, flushing, stale, labels, onClick, compact }: SyncIndicatorProps) {
  const state = rejected > 0 ? 'problem' : !online ? 'offline' : flushing && pending > 0 ? 'syncing' : pending > 0 ? 'pending' : 'synced';
  const tone =
    state === 'problem' || stale
      ? 'bg-danger-soft text-danger ring-danger/25'
      : state === 'offline'
        ? 'bg-warning-soft text-warning ring-warning/30'
        : state === 'pending' || state === 'syncing'
          ? 'bg-info-soft text-info ring-info/25'
          : 'bg-success-soft text-success ring-success/25';
  const text =
    state === 'problem' ? labels.problem : state === 'offline' ? labels.offline : state === 'syncing' ? labels.syncing : state === 'pending' ? labels.pending : labels.synced;
  return (
    <button
      type="button"
      onClick={onClick}
      aria-live="polite"
      title={text}
      className={cx('inline-flex min-h-9 items-center gap-2 rounded-lg px-3 text-xs font-semibold tracking-tight ring-1 ring-inset transition-opacity hover:opacity-90', tone)}
    >
      {state === 'syncing' ? (
        <Spinner size={15} />
      ) : (
        <Icon name={state === 'synced' ? 'cloudCheck' : state === 'offline' ? 'cloudOff' : state === 'problem' ? 'alertCircle' : 'cloud'} size={16} />
      )}
      <span className={cx(compact && 'sr-only sm:not-sr-only')}>{text}</span>
    </button>
  );
}
